module.exports = __webpack_public_path__ + "img/customer.92d64f52.png";